const statusMesin = [
  {
    kode : 0,
    status: "Belum terhubung",
  },
  {
    kode : 1,
    status: "Terhubung",
  },
  {
    kode : 2,
    status: "Menunggu pembayaran",
  },
  {
    kode : 3,
    status: "Masa aktif habis",
  },
  {
    kode : 4,
    status: "Terjadi kesalahan",
  },
]
export default statusMesin;
